"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _immutable = require("immutable");
var _baseLayout = require("./base-layout.constants");
// The initial state of the App
const initialState = exports.initialState = (0, _immutable.fromJS)({
  isSidenavCollapsed: window.innerWidth <= 800,
  loading: false,
  authenticated: false,
  userinfo: null,
  menus: [],
  physicalSiteClaims: [],
  userAppFunctions: null,
  isActionTrackingItemsTOBeAcknowledged: null,
  loadingActionTrackingItemsToBeAcknowledged: false,
  showTodo: false,
  rdsLocation: ""
});
function reducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _baseLayout.LOADING:
      return state.set("loading", action.loading);
    case _baseLayout.SIDENAV_TOGGLE:
      return state.set("isSidenavCollapsed", !state.get("isSidenavCollapsed"));
    case _baseLayout.SIDENAV_HIDE:
      return state.set("isSidenavCollapsed", true);
    case _baseLayout.SIDENAV_SHOW:
      return state.set("isSidenavCollapsed", false);
    case _baseLayout.SIDENAV_MENU:
      return state.set("menus", action.menus);
    case _baseLayout.FINDBYUSERAPPANDFUNCTIONS:
      return state.set("loading", true);
    case _baseLayout.FINDBYUSERAPPANDFUNCTIONS_SUCCESS:
      const {
        userAppFunctions,
        profileImage,
        userinfo
      } = action.data;
      return state.set("authenticated", true).set("userAppFunctions", userAppFunctions).set("userinfo", {
        ...userinfo,
        personId: userAppFunctions.rdsPerId,
        apps: [userAppFunctions.appName],
        roles: [userAppFunctions]
      }).set("profileImage", profileImage.profileImage).set("loading", false);
    case _baseLayout.FINDBYUSERAPPANDFUNCTIONS_ERROR:
      return state.set("authenticated", false).set("loading", false);
    case _baseLayout.UPDATE_BRANDS:
      return state.set("userBrands", action.brands);
    case _baseLayout.SET_SHOW_TODO:
      return state.set("showTodo", action.status);
    case _baseLayout.SET_JWTTOKENSN:
      console.log("SNreducer", action.data);
      return state.set("JwtTokenSN", action.data.jwtToken).set("authenticated", true).set("userAppFunctions", action.data.jwtToken).set("userinfo", {
        apps: [action.data.decoded.appName],
        email: action.data.decoded.email,
        name: action.data.decoded.name,
        userId: action.data.decoded.userId,
        personId: [],
        roles: [],
        department: {
          userId: action.data.decoded.userId,
          companyId: action.data.decoded.companyId,
          companyName: action.data.decoded.companyName,
          companyuserId: action.data.decoded.companyuserId,
          emailId: action.data.decoded.email,
          firstName: action.data.decoded.firstName,
          isAdmin: action.data.decoded.isAdmin,
          lastName: action.data.decoded.lastName,
          name: action.data.decoded.name,
          userKey: action.data.decoded.userKey,
          Dept: action.data.decoded.companyName
        }
      }).set("loading", false);
    case _baseLayout.GET_USER_SESSION_TOKEN:
      return state.set("cacheKeyDetails", action.cacheKeyDetails);
    case _baseLayout.IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED_ERROR:
      return state.set("isActionTrackingItemsTOBeAcknowledged", action.input).set("loadingActionTrackingItemsToBeAcknowledged", false);
    case _baseLayout.COMMON_SERVICE_SUCCESS:
      return Object.keys(action).filter(key => key !== "type").reduce((acc, key) => {
        return acc.set(key, action[key] || initialState.get(key));
      }, state);
    case _baseLayout.SET_ACTION_TRACKING_TO_BE_ACKNOWLEDGED:
      return state.set("isActionTrackingItemsTOBeAcknowledged", action.count).set("loadingActionTrackingItemsToBeAcknowledged", false);
    case _baseLayout.LOADING_ACTION_TRACKING_TO_BE_ACKNOWLEDGED:
      return state.set("loadingActionTrackingItemsToBeAcknowledged", action.load);
    case _baseLayout.SET_PERSONA_FOR_USER:
      return state.set("userPersona", action.personaData);
    case _baseLayout.SET_USER_GRID_COLUMNS:
      return state.set("adaSetting", action.adaSetting);
    default:
      return state;
  }
}
var _default = exports.default = reducer;